import {ModuleWithProviders, NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {DxBaseModalComponent} from "./ui/components/dx-base-modal.component";
import {DxInfoModalComponent} from "./ui/components/info/dx-info-modal.component";
import {DxModalService} from "./services/dx-modal.service";
import {SuiModalModule} from "ng2-semantic-ui";
import {DxWarnModalComponent} from "./ui/components/warn/dx-warn-modal.component";
import {DxErrorModalComponent} from "./ui/components/error/dx-error-modal.component";
import {DxConfirmModalComponent} from "./ui/components/confirm/dx-confirm-modal.component";
import {DxModalContentHostDirective} from "./ui/directives/dx-modal-content-host.directive";
import {DxEditModalComponent} from "./ui/components/edit/dx-edit-modal.component";
import {DxGridModule} from "../dx-grid/dx-grid.module";
import {DxFormsModule} from "../dx-forms/dx-forms.module";
import {DxCoreModule} from "../dx-core/dx-core.module";


/**
 * Модуль предоставляет функциональность модальных окон:
 * 1. Info
 * 2. Error
 * 3. Warn
 * 4. Confirm
 * 5. Модальное окно для отображаения произвольного компонента.
 */
@NgModule({
  declarations: [
    DxBaseModalComponent,
    DxInfoModalComponent,
    DxWarnModalComponent,
    DxErrorModalComponent,
    DxConfirmModalComponent,
    DxEditModalComponent,
    DxModalContentHostDirective
  ],
  entryComponents: [
    DxBaseModalComponent,
    DxInfoModalComponent,
    DxWarnModalComponent,
    DxErrorModalComponent,
    DxConfirmModalComponent,
    DxEditModalComponent
  ],
  exports: [
  ],
  imports: [
    CommonModule,
    FormsModule,
    SuiModalModule,
    DxGridModule,
    DxFormsModule,
    DxCoreModule
  ],
  providers: [
    DxModalService
  ],
  bootstrap: []
})
export class DxModalsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DxModalsModule,
      providers: [
        DxModalService
      ]
    };
  }
}
